module.exports = __webpack_public_path__ + "img/compare.8ec1cc7b.svg";